module.exports = __webpack_public_path__ + "democraticdesign.jpg?f62482d7a13a4055a1ff91c2d8e572b6";


//////////////////
// WEBPACK FOOTER
// ./static/democraticdesign.jpg
// module id = 100
// module chunks = 0